const adminUserConstantsEn = {
  adminUserUserManagementBreadcrumbs: 'User Management',
  adminUserBreadcrumbsUpdate: 'Update User',
  adminUserCreateHeaderTitle: 'Create User',
  adminUserEditHeaderTitle: 'Edit',
  adminUserSubtitle1: 'SAYMA USER INFO',
  adminUserSubtitle2: 'SAYMA USER ROLE',
  adminUserSubtitle3: 'SAYMA USER PERMISSIONS',
  adminUserEmailLabel: 'User Email',
  adminUserFirstNameLabel: 'First Name',
  adminUserLastNameLabel: 'Last Name',
  adminUserPasswordLabel: 'Password',
  adminUserConfirmPasswordLabel: 'Confirm Password',
  adminUserRoleLabel: 'User Role',
  adminUserRoleOption1: 'Admin',
  adminUserRoleOption2: 'Data Entry',
  adminUserSaveButton: 'Save',
  adminUserCreateButton: 'Create User',
  adminCreatedSuccessfully: 'User Created Successfully',
  existedEmailValidationError: 'This email is already registered, try another one',
};

export default adminUserConstantsEn;
